import Vue from 'vue';
import { Promised } from 'vue-promised';

Vue.component('Promised', Promised);
